import React from 'react';
import StopListing from './StopListing';
import Timetable from './Timetable';

const bem = 'tt-stops-timetable';
export default class StopsTimetable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.StopTimetable = React.createRef();
  }

  componentDidMount() {
    if (window.innerHeight < 641) this.StopTimetable.current.scrollIntoView();
  }

  render() {
    const props = this.props;
    const { timetables, selectedHeadsign } = this.props;
    const hideMobileStopList = !!timetables;

    // when there is no route dropdown, we need to round the top-left top-right corners
    const shouldShowDropdown = selectedHeadsign && selectedHeadsign.routes && selectedHeadsign.routes.length > 1;
    const bemStopsRounded = shouldShowDropdown ? '' : `${bem}--rounded`;

    return (
      <div ref={this.StopTimetable} className={`${bem}  ${bemStopsRounded}`}>
        <span className={`${bem}__stoplist ${hideMobileStopList ? 'hidden-mobile' : ''}`}><StopListing {...props} /></span>
        <span className={`${bem}__timetable`}><Timetable {...props} /></span>
      </div>
    );
  }
}
